import cx from 'classnames';
import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import * as style from './styles.css';

export interface IAnswerItemProps {
  aside: React.ReactNode;
  author: React.ReactNode;
  comment: React.ReactNode;
  footer: React.ReactNode;
  inPopup?: boolean;
}

export const AnswerItem: React.FC<IAnswerItemProps> = props => {
  const { aside, author, comment, footer, inPopup } = props;

  return (
    <div data-testid="ReviewItem" className={cx(style['container'], inPopup && style['container--popup'])}>
      <Responsive desktop>
        <div className={style['aside']}>{aside}</div>
      </Responsive>
      <div className={style['main']}>
        <div className={style['main-heading']}>
          <Responsive phone tablet>
            <div className={style['aside']}>{aside}</div>
          </Responsive>
          <div className={style['author']}>{author}</div>
        </div>
        <div className={style['comment']}>{comment}</div>
        <div className={style['footer']}>{footer}</div>
      </div>
    </div>
  );
};
